import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, Divider, Grid2, IconButton, Link, Menu, MenuItem, Paper, SpeedDial, SpeedDialAction, SpeedDialIcon, Typography, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import _ from "lodash";
import moment from 'moment';
import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sticky from 'react-sticky-el/lib/basic-version';
import { lighter } from "../common/util";
import { DialogsContext, SessionDataContext } from "../contexts";
import StudentName from "../student/student.name";
import SubjectName from '../subject/subject.name';
import { termApi } from './term.queries';
import { useMenu } from '../common/dialog.util';

export default function TermView(props) {
	const navigate = useNavigate();
	const { id } = useParams();
	const useGet = termApi.useGet(id);
	const term = useGet?.data;

	const useDelete = termApi.useDelete();

	const theme = useTheme();
	const menu = useMenu();
	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);

	const onDelete = async () => {
		await useDelete.mutateAsync(term.id);
		if (window.location.pathname.startsWith('/terms/' + term.id)) {
			navigate('/terms');
		}
	};

	if (!term) {
		return;
	}

	const optionsMenu = (
		<Box>
			<IconButton className={menu.isOpen ? '' : 'hover-muted'} onClick={(e) => menu.open(e)} sx={{ mr: -1 }}>
				<MoreVertIcon />
			</IconButton>
			<Menu open={menu.isOpen} onClose={() => menu.close()} anchorEl={menu.anchor}>
				<MenuItem onClick={() => { menu.close(); dialogs.open('term', term) }}>Edit</MenuItem>
				<Divider />
				<MenuItem onClick={() => { menu.close(); onDelete(term.id) }}>Delete</MenuItem>
			</Menu>
		</Box>
	);

	const startLabel = moment(term.startDate).format('MMMM D, YYYY');
	const endLabel = moment(term.endDate).format('MMMM D, YYYY');

	const renderSubject = (subject, enrollments) => {
		enrollments = _.sortBy(enrollments, 'course.name');

		const termLength = term.endDate - term.startDate;
		return (
			<Box key={subject.id}>
				<Stack alignItems="center">
					<SubjectName subject={subject} size={20}></SubjectName>
					<Typography color="muted">({enrollments.length})</Typography>
				</Stack>
				{/* {enrollments?.length > 0 &&
					enrollments?.map(enrollment => {
						const start = term.startDate >= enrollment.startDate ? 0 : ((enrollment.startDate - term.startDate) / termLength) * 100;
						const end = term.endDate < enrollment.endDate ? 100 : ((enrollment.endDate - term.startDate) / termLength) * 100;
						const width = Math.max(end - start, 25);

						return (
							<Box key={enrollment.id} sx={{ position: 'relative', my: 2, left: start + '%', width: width + '%' }}>
								{enrollment.score > 0 && enrollment.score == maxScore && bestRibbon}
								<EnrollmentCard2 enrollment={enrollment} hideSubject={true} />
							</Box>
						);
					})
				}
				{enrollments?.length == 0 &&
					<Typography sx={{ p: 8, fontSize: '1.25rem', fontStyle: 'italic', textAlign: 'center', flex: 1, color: 'muted' }}>-- No enrollments --</Typography>
				} */}
			</Box>
		);
	};

	let studentSections = '';
	if (term.enrollments?.length) {
		studentSections = _.chain(term.enrollments).sortBy(['student.name', 'course.subject.name', 'course.name']).groupBy('studentId').map((enrollments, studentId) => {

			const gridSx = { outline: '4px solid ' + lighter(enrollments[0].student.colour, 0.8, theme), borderRadius: 1 };

			const subjects = _.chain(enrollments).map('course.subject').uniqBy('id').value();

			return (
				<Grid2 size={{ sm: 6, md: 4, lg: 3 }} sx={gridSx} key={studentId}>
					<Paper sx={{ height: '100%' }}>
						<Stack justifyContent="space-between" sx={{ p: 2 }}>
							<Stack alignItems="center">
								<Link onClick={() => navigate('/terms/' + term.id + '/students/' + enrollments[0].studentId)}>
									<StudentName student={enrollments[0].student} variant="h5" hideLink={true} />
								</Link>
							</Stack>
							<Stack direction="column" spacing={0}>
								<Typography>{subjects.length} Subjects</Typography>
								<Typography>{enrollments.length} Topics/Courses</Typography>
							</Stack>
						</Stack>
						<Stack direction="column" sx={{ px: 4, pb: 2 }} spacing={1}>
							{subjects.map(subject => {
								const subjectEnrollments = _.filter(enrollments, enrollment => enrollment?.course?.subjectId == subject.id);
								return renderSubject(subject, subjectEnrollments);
							})}

							<Button variant="outlined" sx={{ alignSelf: 'start', p:0, ml: '24px !important' }}>
								<Stack alignItems="center">
									<AddIcon />
									<Typography variant="subtitle1" sx={{ml:'3px !important'}}>Add</Typography>
								</Stack>
							</Button>
						</Stack>
					</Paper>
				</Grid2>
			);
		}).value();
	}

	return (
		<Box sx={{ p: 4 }}>
			<Sticky stickyStyle={{ backgroundColor: theme.palette.background.default, zIndex: 10, top: theme.mixins.toolbar["@media (min-width:600px)"].minHeight }} topOffset={-theme.mixins.toolbar["@media (min-width:600px)"].minHeight}>
				<Stack sx={{ mb: 4 }} justifyContent="center" alignItems="center">
					<Typography variant="h4">{term.name}</Typography>
					{optionsMenu}
				</Stack>
			</Sticky>

			<Grid2 container spacing={4}>
				{studentSections}
			</Grid2>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>Enroll a Student</Typography>} onClick={() => dialogs.open('enrollment', { startDate: term.startDate, endDate: term.endDate })} />
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>New Term</Typography>} onClick={() => dialogs.open('term', {})} />
			</SpeedDial>
		</Box>
	);
}